$(document).ready(function () {
  var domainShop = "1k6ssf-kg.myshopify.com";
  var HIDE_THRESHOLD = 20000;

  var subtotalObserver = null;
  var cartObserver = null;
  var updateTimer = null;
  var lastSubtotal = null;

  function formatAmount(value) {
    return new Intl.NumberFormat("en-PK", {
      maximumFractionDigits: 0
    }).format(Math.round(value || 0));
  }

  function parseMoney(text) {
    if (!text) return 0;

    var str = String(text).replace(/\u00a0/g, " ").trim();

    // Extract numeric parts like:
    // Rs. 15,000.00
    // PKR 15000
    // 15,000
    var matches = str.match(/(\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:\.\d+)?)/g);

    if (!matches || !matches.length) return 0;

    // Usually the last numeric group is the actual amount
    var raw = matches[matches.length - 1].replace(/,/g, "");
    var num = parseFloat(raw);

    return isNaN(num) ? 0 : Math.round(num);
  }

  function getPercentageFromStore() {
    var p = parseFloat(sessionStorage.getItem("percentageAmount"));
    return isNaN(p) ? 0 : p;
  }

  function setPercentageToStore(result) {
    if (!Array.isArray(result) || !result.length) return;

    var fee = result[0] && result[0].fee ? result[0].fee : 0;
    var pct = parseInt(fee, 10);

    if (!isNaN(pct)) {
      sessionStorage.setItem("percentageAmount", String(pct / 100));
    }
  }

  function updateShopLimits(result) {
    var maxL = result && result[0] ? result[0].max_shop_limit : "";
    var minL = result && result[0] ? result[0].min_shop_limit : "";

    $("#upperlimit, .upperlimit").text(formatAmount(parseMoney(maxL)));
    $("#lowerlimit, .lowerlimit").text(formatAmount(parseMoney(minL)));
  }

  function getSubtotalElement() {
    return (
      document.querySelector(".t4s-cart__totalPrice") ||
      document.querySelector(".totals__subtotal .money") ||
      document.querySelector(".cart__footer .totals__subtotal-value") ||
      document.querySelector(".cart-drawer .totals__subtotal-value")
    );
  }

  function hideShowWidget(cartTotal) {
    var $widget = $(".drawer-total-label");
    if (!$widget.length) return;

    if (cartTotal >= HIDE_THRESHOLD) {
      $widget.addClass("drawer-hidden").attr("hidden", true).css("display", "none");
    } else {
      $widget.removeClass("drawer-hidden").removeAttr("hidden").css("display", "");
    }
  }

  function updateInstallment(cartTotal) {
    var percentage = getPercentageFromStore();
    var feeAmount = cartTotal * percentage;
    var installment = Math.floor((cartTotal + feeAmount) / 3);

    var $installmentEl = $(".price-divide-cart");
    if ($installmentEl.length) {
      $installmentEl.text(formatAmount(installment));
    }

    hideShowWidget(cartTotal);
  }

  function updateBaadmayPrice1() {
    var subtotalEl = getSubtotalElement();
    if (!subtotalEl) return;

    var subtotalText = subtotalEl.textContent || subtotalEl.innerText || "";
    var cartTotal = parseMoney(subtotalText);

    if (cartTotal === lastSubtotal) return;
    lastSubtotal = cartTotal;

    updateInstallment(cartTotal);
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(function () {
      updateBaadmayPrice1();
    }, 120);
  }

  function observeSubtotalNode() {
    if (subtotalObserver) {
      try {
        subtotalObserver.disconnect();
      } catch (e) {}
      subtotalObserver = null;
    }

    var subtotalEl = getSubtotalElement();
    if (!subtotalEl) return;

    subtotalObserver = new MutationObserver(function () {
      scheduleUpdate();
    });

    subtotalObserver.observe(subtotalEl, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function observeCartContainer() {
    if (cartObserver) {
      try {
        cartObserver.disconnect();
      } catch (e) {}
      cartObserver = null;
    }

    var container =
      document.querySelector("#CartDrawer") ||
      document.querySelector(".cart-drawer") ||
      document.querySelector(".cart") ||
      document.body;

    cartObserver = new MutationObserver(function (mutations) {
      var shouldRefresh = false;

      mutations.forEach(function (mutation) {
        if (shouldRefresh) return;

        if (mutation.target && $(mutation.target).closest(".baadmay-gateway-wrapper").length) {
          return;
        }

        if (mutation.type === "childList") {
          if (mutation.addedNodes.length || mutation.removedNodes.length) {
            shouldRefresh = true;
          }
        }
      });

      if (shouldRefresh) {
        observeSubtotalNode();
        scheduleUpdate();
      }
    });

    cartObserver.observe(container, {
      childList: true,
      subtree: true
    });
  }

  function fetchBaadmayData() {
    var storedData = sessionStorage.getItem("baadmayData");

    if (storedData) {
      return Promise.resolve(JSON.parse(storedData));
    }

    return $.get("https://cms.baadmay.com/Fees?merchant_name=" + domainShop).then(function (data) {
      sessionStorage.setItem("baadmayData", JSON.stringify(data));
      return data;
    });
  }

  $(document).on(
    "input change click",
    [
      ".ajax-cart__qty-input",
      ".ajax-cart__qty-control--down",
      ".ajax-cart__qty-control--up",
      ".quantity.cart-update.buttons_added",
      ".remove.cart-remove-desktop",
      ".single_add_to_cart_button.button",
      '[name="quantity"]',
      ".cart__qty-input",
      ".cart-item__quantity-wrapper button",
      ".quantity__button",
      ".cart-remove-button",
      ".t4s-cart__totalPrice",
      "span.hdt-totals__total-value.hdt-mini-cart__value.hdt-text-2xl.hdt-s-text.hdt-font-semibold.hdt-money"
    ].join(","),
    function () {
      scheduleUpdate();
    }
  );

  $(document).on("cart:refresh cart:updated", function () {
    observeSubtotalNode();
    scheduleUpdate();
  });

  fetchBaadmayData().then(function (data) {
    setPercentageToStore(data);
    updateShopLimits(data);
    observeSubtotalNode();
    observeCartContainer();
    updateBaadmayPrice1();
  });
});